import PropTypes from 'prop-types';
import React, { Component } from 'react';
import MetaLoader from '../../../../../components/meta-loader';
import PageTitles from '../../../../../components/meta-page-titles';
import SetEmailForm from '../../../../../components/set-email';
import { FormError } from '../../../../../components/form-fields';
import Localization from '../../../../../assets/localization';
import { ROUTES } from '../../../../../consts/routes';

class SetEmailPage extends Component {
  render() {
    const { loading, errorMessage } = this.props;
    return (
      <div className="set-email-container">
        <div className="form-background">
          <div className="form-content">

            <PageTitles
              subtitle={Localization.SET_EMAIL_PAGE.TITLE}
            />
            <SetEmailForm
              initialValues={{ email: this.props.email }}
              onSubmit={this.props.setEmail}
              loading={this.props.loading}
              handleLinkClick={this.props.handleLinkClick}
              formTitle={Localization.SET_EMAIL_PAGE.EMAIL_FIELD_TITLE}
              bottomLinkTextBefore={Localization.SET_EMAIL_PAGE.HAVE_AN_ACCOUNT_LABEL}
              bottomLinkTitle={Localization.SET_EMAIL_PAGE.HAVE_AN_ACCOUNT_LINK}
              bottomLinkHref={ROUTES.LOGIN}
            />
          </div>
          { loading
            ? <div className="loader-wrapper"><MetaLoader isShown={loading} /></div>
            : <FormError message={errorMessage} isShown={Boolean(errorMessage)} />}
        </div>
      </div>
    );
  }
}

SetEmailPage.defaultProps = {
  errorMessage: '',
  loading: false,
  setEmail: () => {},
  handleLinkClick: () => {},
};

SetEmailPage.propTypes = {
  errorMessage: PropTypes.string,
  loading: PropTypes.bool,
  setEmail: PropTypes.func,
  handleLinkClick: PropTypes.func,
};

export default SetEmailPage;
